<nz-footer>© 2023 Nielsen Consumer LLC. All Rights Reserved.</nz-footer>
